import React from "react";
import { Col, Row } from "react-bootstrap";
import { isRgbColorEnabled, getScaleColors } from "../../../../../../Helpers/RgbColorHelper";

export default function Summary_L_Bar({ item, isSub }) {
  let elementScore = item.normScore ? Math.round(Number(item.normScore)) : Math.round(item.score);

  // Check if RGB color is enabled using helper
  const rgbEnabled = isRgbColorEnabled(item.scale);

  // Get color variations using helper only if RGB is enabled
  const colors = rgbEnabled ? getScaleColors(item.scale) : null;

  // Default colors
  const progressColor = rgbEnabled ? colors.primary : "#4a90e2";
  const backgroundColor = rgbEnabled ? colors.light : "#e0e0e0";

  return (
    <Row className={"mx-0"} style={{ marginBottom: "30px", marginTop: "50px" }}>
      <Col xs="4" className="d-flex align-items-center ">
        <div
          style={{
            fontSize: isSub ? "22px" : "26px",
            fontWeight: "600",
            color: rgbEnabled ? (!isSub ? colors.dark : colors.primary) : "#333",
            textTransform: "uppercase",
          }}
        >
          {item.name}
        </div>
      </Col>
      <Col xs="8">
        <div style={{ display: "flex", alignItems: "center", gap: "15px", float: "right" }}>
          {/* Percentage text */}
          <div
            style={{
              fontSize: "24px",
              fontWeight: "600",
              color: rgbEnabled ? colors.dark : "#333",
              minWidth: "65px",
            }}
          >
            {elementScore}%
          </div>

          {/* Loading bar */}
          <div
            style={{
              width: "860px",
              height: "36px",
              backgroundColor: backgroundColor,
              borderRadius: "18px",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <div
              style={{
                height: "100%",
                width: `${elementScore}%`,
                backgroundColor: progressColor,
                borderRadius: "18px",
                transition: "width 0.3s ease",
              }}
            />
          </div>
        </div>
      </Col>
    </Row>
  );
}
